import { Router } from '@angular/router';
import { Component, ViewChild } from '@angular/core';
import { ModalComponent } from '../modal.component/modal.component';
import { PlayerService } from 'src/app/services';

@Component({
  selector: 'app-order-expired-modal',
  templateUrl: './order-expired-modal.component.html',
  styleUrls: ['./order-expired-modal.component.scss']
})
export class OrderExpiredModalComponent {
  @ViewChild('modal') public modal: ModalComponent;

  public constructor(private router: Router) {}

  public onCloseClick(): void {
    this.modal.close('closed by click');
     window.location.href = '/min-side'
  }

  public open(closeable = true): void {
    this.modal.open(closeable);
  }
}


